import { useNostrPublish } from './useNostrPublish';
import { useToast } from './useToast';
import type { BitcoinBlock } from './useBitcoinBlocks';

export function useShareBlock() {
  const { mutateAsync: publish } = useNostrPublish();
  const { toast } = useToast();

  const shareBlock = async (block: BitcoinBlock) => {
    try {
      const content = `⚰️ New Block Alert! ⚰️

Bitcoin block #${block.height.toLocaleString()} has just been mined from the depths of the blockchain!

📊 Block Details:
• Transactions: ${block.tx_count.toLocaleString()}
• Size: ${(block.size / 1024 / 1024).toFixed(2)} MB
• Mined: ${new Date(block.timestamp * 1000).toLocaleString()}

View this eternal tombstone in the Block Cemetery: 
${window.location.origin}

#bitcoin #blockchain #crypto #halloween #blockcemetery`;

      const event = await publish({
        kind: 1,
        content,
        tags: [
          ['t', 'bitcoin'],
          ['t', 'blockchain'],
          ['t', 'crypto'],
          ['t', 'halloween'],
          ['t', 'blockcemetery'],
          ['e', block.id], // Reference to the block hash
          ['alt', `Shared Bitcoin block #${block.height} from Block Cemetery`],
        ],
      });

      toast({
        title: 'Block Shared to Nostr!',
        description: `Block #${block.height} has been shared with your followers.`,
      });

      return event;
    } catch (error) {
      toast({
        title: 'Failed to Share Block',
        description: error instanceof Error ? error.message : 'Unknown error occurred',
        variant: 'destructive',
      });
      throw error;
    }
  };

  return { shareBlock };
}
